import * as React from "react";
import styled from "styled-components";
import safeGet from "lodash/get";
import { HeadingLink } from "../../Text";
import { COLOURS } from "../../../consts/style";
import { Link } from "../../Link";
import { TRACKING_CODES } from "../../../consts/trackingCodes";

export function getContent(publicPath) {
  return {
    prospectContent: {
      href: "/electricity-gas/plans.html",
      heading: "Electricity and gas",
      text: "Compare our energy plans side by side.",
      imageUrl: `${publicPath}prospect.png`,
      tracking: TRACKING_CODES.PERSONALISED_CONTENT_PROSPECTS,
    },
    movingContent: {
      href: "/for-home/moving.html",
      heading: "Moving house?",
      text: "We'll connect you.",
      imageUrl: `${publicPath}moving.png`,
      tracking: TRACKING_CODES.PERSONALISED_CONTENT_MOVING,
    },
  };
}

const InnerContainer = styled(Link)`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  max-width: 375px;
  text-decoration: none;
`;

const StyledText = styled.div`
  margin-top: 8px;
  font-size: 14px;
  color: ${COLOURS.GREY.GREY_80};
`;

const ImageContainer = styled.div`
  width: 104px;
`;

const Image = styled.img`
  width: 100%;
`;

const HeadingContainer = styled.div`
  width: 70%;
  margin-right: 16px;
`;

const Container = styled.div`
  padding: 24px 16px;
`;

interface ContentProps {
  href: string;
  heading: string;
  text: string;
  imageUrl: string;
  tracking: string;
}

export const Content: React.FC<ContentProps> = ({
  href,
  heading,
  text,
  imageUrl,
  tracking,
}) => (
  <InnerContainer href={href} data-id={tracking}>
    <HeadingContainer>
      <HeadingLink inline>{heading}</HeadingLink>
      <StyledText>{text}</StyledText>
    </HeadingContainer>
    <ImageContainer>
      <Image src={imageUrl} alt={`Image for ${heading}`} />
    </ImageContainer>
  </InnerContainer>
);

Content.displayName = "personalised-content";

interface PersonalisedContentProps {
  menuVisible: boolean;
}

interface PersonalisedContentState {
  show: boolean;
  prospect: boolean;
  moving: boolean;
  publicAssetsPath: string;
}

interface Audience {
  prospect?: boolean;
  moving?: boolean;
}

interface OfferContent {
  content: Audience[];
}

export class PersonalisedContent extends React.Component<
  PersonalisedContentProps,
  PersonalisedContentState
> {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      prospect: false,
      moving: false,
      publicAssetsPath: "/",
    };
  }

  fetchOffer = () => {
    if (safeGet(window, "adobe.target.getOffer")) {
      //@ts-ignore
      window.adobe.target.getOffer({
        mbox: "OE-234-mbox",
        success: (offer: OfferContent[]) => {
          const prospect = safeGet(offer, "[0].content[0].prospect");
          const moving = safeGet(offer, "[0].content[0].moving");
          if (prospect) {
            this.setState({ show: true, prospect: true });
          } else if (moving) {
            this.setState({ show: true, moving: true });
          }
        },
        error: () => {},
      });
    }
  };

  componentDidMount() {
    this.setState({
      publicAssetsPath: safeGet(window, "oetal.env.talPublicAssetsPath") || "/",
    });

    this.fetchOffer();
  }
  componentDidUpdate(prevProps: PersonalisedContentProps) {
    if (!prevProps.menuVisible && this.props.menuVisible) {
      this.fetchOffer();
    }
  }

  render() {
    const { show, prospect, moving, publicAssetsPath } = this.state;

    if (!show) {
      return null;
    }

    const { prospectContent, movingContent } = getContent(publicAssetsPath);

    return (
      <Container>
        {prospect && <Content {...prospectContent} />}
        {moving && <Content {...movingContent} />}
      </Container>
    );
  }
}
